import PropTypes from "prop-types";
import React from "react";
import { FaInfoCircle } from "react-icons/fa";
import { Tooltip } from "react-tooltip";
import "react-tooltip/dist/react-tooltip.css";

function jsxToHtml(content) {
    if(typeof content === "string") return content;
    // Simple JSX to HTML conversion for span/strong/br
    if(React.isValidElement(content)) {
        let html = "";
        React.Children.forEach(content.props.children, (child) => {
            if(typeof child === "string") {
                html += child;
            } else if(child && child.type === "strong") {
                html += `<strong>${child.props.children}</strong>`;
            } else if(child && child.type === "br") {
                html += "<br />";
            } else if(React.isValidElement(child)) {
                html += jsxToHtml(child);
            }
        });
        return html;
    }
    return String(content);
}

const InfoTooltip = ({ id, content }) => {
    const htmlContent = jsxToHtml(content);
    return (
        <>
            <FaInfoCircle
                data-tooltip-id={id}
                data-tooltip-html={htmlContent}
                className="text-navy inline-block ml-1 cursor-pointer"
            />
            <Tooltip
                id={id}
                place="top"
                className="max-w-xs text-sm font-poppins z-50"
            />
        </>
    );
};

InfoTooltip.propTypes = {
    id: PropTypes.string.isRequired,
    content: PropTypes.node.isRequired,
};
export default InfoTooltip;
